/* eslint-disable no-param-reassign */
import { createBasicSelector } from 'util/redux'
import { selectReactionTitlesByReactionForEventGroup } from './selectReactionTitlesByReactionForEventGroup'

export const selectReactionTitleForEventGroupAndReaction = createBasicSelector(
  selectReactionTitlesByReactionForEventGroup,
  (_state, _groupId, reaction) => reaction,
  (reactionTitlesByReaction, reaction) => reactionTitlesByReaction[reaction]
)
